<template>
  <footer class="SectionFooter">
    <b-container>
      <b-row class="SectionFooter__top-content ml-0 mr-0">
        <b-col
          cols="12"
          md="6"
          class="p-0"
        >
          <inline-svg
            class="Logo Logo--light Logo--large"
            :src="require('@/assets/poetix-logo.svg')"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="p-0"
        >
          <p class="SectionFooter__copyright">
            &copy; {{ new Date().getFullYear() }} Lorem ipsum dolor si amet
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="1"
        >
          <b-nav vertical>
            <footer-menu />
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import FooterMenu from './blocks/FooterMenu.vue'
export default { components: { FooterMenu } }
</script>

<style scoped lang="scss">
.SectionFooter {
  padding-top: 1.7em;
  padding-bottom: 10em;
  width: 100%;
  background: $dark;

  &__top-content {
    display: none;
    border-bottom: 2.5px solid $white;
    padding-bottom: 1em;
    margin-bottom: 1em;

    @include media-breakpoint-up(md) {
      display: flex;
    }
  }

  &__copyright {
      margin-top: 1.6em;
      color: $white;
      text-align: right;
    }
}
</style>
